import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    no: "01",
    title: "Brand Strategy",
    desc: "We pressure-test your thinking before we design a single pixel. Clarity first, always.",
    tags: ["Positioning", "Naming", "Messaging"],
  },
  {
    no: "02",
    title: "Core Visual Identity",
    desc: "Logo, type, color, system. A brand guide that holds up everywhere it's used.",
    tags: ["Logo", "Type", "Systems"],
  },
  {
    no: "03",
    title: "Packaging Art Direction",
    desc: "Direction and specs for your hero products, built to extend as your line grows.",
    tags: ["Art Direction", "Specs", "Print"],
  },
  {
    no: "04",
    title: "Brand Storytelling & Launch",
    desc: "Messaging, narrative, and a runway to build an audience before you launch.",
    tags: ["Narrative", "Launch", "Audience"],
  },
];

const Row = ({ s, i }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      data-testid={`service-row-${i + 1}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="group relative overflow-hidden border-t border-black/15 last:border-b"
    >
      {/* cobalt fill */}
      <motion.div
        className="absolute inset-0 origin-bottom bg-[#0047FF]"
        initial={false}
        animate={{ scaleY: hover ? 1 : 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        aria-hidden
      />
      <div className="relative z-10 flex items-center gap-6 px-1 py-8 md:py-11">
        <span
          className={`text-xs font-semibold tabular-nums tracking-widest transition-colors duration-300 ${
            hover ? "text-white/70" : "text-[#0a0a0a]/40"
          }`}
        >
          {s.no}/04
        </span>
        <h3
          className={`tight font-extrabold text-[8vw] md:text-[3.6vw] leading-none transition-colors duration-300 ${
            hover ? "text-white" : "text-[#0a0a0a]"
          }`}
        >
          {s.title}
        </h3>

        <div className="ml-auto flex items-center gap-8">
          <AnimatePresence>
            {hover && (
              <motion.p
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.35 }}
                className="hidden lg:block max-w-xs text-right text-sm leading-relaxed text-white/90 font-medium"
              >
                {s.desc}
              </motion.p>
            )}
          </AnimatePresence>
          <motion.span
            animate={{ rotate: hover ? 45 : 0, color: hover ? "#fff" : "#0a0a0a" }}
            transition={{ duration: 0.4 }}
            className="text-3xl md:text-4xl leading-none"
          >
            {"\u2197\uFE0E"}
          </motion.span>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#f7f3ea] py-24 md:py-40"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <Reveal className="mb-14">
          <span className="label text-[#0a0a0a]/40">(What we offer)</span>
          <h2 className="tight font-extrabold text-[#0a0a0a] text-5xl md:text-7xl mt-4">
            Ways to work.
          </h2>
        </Reveal>

        <div>
          {SERVICES.map((s, i) => (
            <Row key={s.no} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
